import { useEffect, useMemo, useRef, useState } from 'react';
// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'; //useRef
// import { View, Text, Image, FlatList, ViewToken, ActivityIndicator, Pressable, Alert, AppState, ScrollView, Animated, Platform } from 'react-native'; //ScrollView
// import {Calendar, CalendarList, Agenda, LocaleConfig} from 'react-native-calendars';
// import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
// import AgendaImg from '../../assets/images/twitcook_logo.png';
// import { AgendaRouteProp, CreateOpenShiftRouteProp, CreateShiftRouteProp, HomeTabRouteProp, MapRouteProp, OpenShiftRouteProp, PostsRouteProp, ShiftRouteProp, UsersRouteProp } from '../../Types/navigation';
// import { useFocusEffect, useNavigation, useRoute } from '@react-navigation/native';
import { useAuthContext } from '../../contexts/AuthContext';
// import styles from './styles';
import { useLazyQuery, useMutation, useQuery, useSubscription, ApolloError } from '@apollo/client';
import {  AgendaShift, AgendaUserType, ComByUserIdQuery, ComByUserIdQueryVariables, CreateAgendaPunchMutation, CreateAgendaPunchMutationVariables, GetAgendaCompanyQuery, GetAgendaCompanyQueryVariables, ListAgendaPostsQuery, ListAgendaPostsQueryVariables, ModelSortDirection, ShiftAppsByComIdQuery, ShiftAppsByComIdQueryVariables, ShiftAppsByUserQuery, ShiftAppsByUserQueryVariables, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables } from '../../graphql/API';
import { comByUserId, getAgendaUser, shiftAppsByComId, shiftAppsByUser, shiftsByUser, updateAgendaUser } from './queries';
// import ApiErrorMessage from '../../components/ApiErrorMessage';
import UserImage from '../../components/UserImage';
// import Ionicons from 'react-native-vector-icons/Ionicons';
// import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
// import Foundation from 'react-native-vector-icons/Foundation';
// import Entypo from 'react-native-vector-icons/Entypo';
import { signOut } from 'aws-amplify/auth';
// import messaging from '@react-native-firebase/messaging';
// import notifee, { EventType } from '@notifee/react-native';
// import storage from '../../Storage';
import { v4 as uuidv4 } from 'uuid';
// import dayjs from 'dayjs';
// import colors from '../../themes/colors';
import { useNotification } from '../../contexts/NotificationProvider';
// import useUserFirstService from '../services/UserService/UserFirstService';
// import I18n from '../../../i18n';
// import { I18n } from "i18n-js";
// import translations from "../../../locales/translation.json";
// import DropShadow from 'react-native-drop-shadow';
import useNotificationStorageService from '../services/NotificationStorageService';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Badge, Card, Col, Container, Modal, Row, Spinner, Button } from 'react-bootstrap';
import { FaCalendarCheck, FaUsers, FaPaperPlane, FaUserTie, FaCartShopping, FaCreditCard, FaClipboardQuestion, FaArrowTurnDown } from 'react-icons/fa6';

import { MdNewReleases, MdFiberNew, MdPunchClock } from "react-icons/md";
import { IoIosMegaphone } from 'react-icons/io';
import { IoArrowRedoCircleOutline, IoDocumentAttach } from "react-icons/io5";
import Sidebar from '../services/Sidebar/Sidebar';
import CustomModal from '../../components/Modals/CustomModal';
import { format } from 'date-fns';
import { enUS, fr, is } from 'date-fns/locale';
import axios from 'axios';
import useDateService from '../services/DateService';
import useHelperService from '../services/HelperService';
import { PUBLIC_ID } from '../../config';
import { Toast, ToastContainer } from 'react-bootstrap';
import CompanyLogo from '../../components/CompanyLogo';

// Fonction pour détecter si on est dans ton App macOS (optionnel)
declare global {
  interface Window {
    webkit?: {
      messageHandlers?: any;
    };
  }
}
const isMacOSApp = window.webkit?.messageHandlers;

const subscribeToTopicsNative = (comIdTopic: string, userIdTopic: string) => {
    if (window.webkit?.messageHandlers?.callbackHandler) {
        
        window.webkit.messageHandlers.callbackHandler.postMessage({ 
            action: "subscribeTopic", 
            topic: comIdTopic 
        });
        
        window.webkit.messageHandlers.callbackHandler.postMessage({ 
            action: "subscribeTopic", 
            topic: userIdTopic
        });
        
        console.log("MacOS system ask for topic subscriptions");
    }
};

interface NetworkErrorWithStatusCode extends Error {
  statusCode?: number; // Utilisez '?' pour indiquer que c'est facultatif
  result?: any; // Peut aussi avoir d'autres propriétés comme 'result'
}
// import spinner from "../../assets/images/loading.gif";

// BACKEND (COMPANY & FCM TOPICS)
const getComId = async (email: string) => {
  try {
    // console.log("POST", email);
    const response = await axios.post("/api/get_worker/comId", {
      email: email,
    });

    // console.log("Get Work ComId:", response.data);
    return response.data; // Retourne le client token
  } catch (error) {
    console.error("Error when getting worker comId :", error);
    return null;
  }
};

const getManager = async (email: string) => {
  try {
    // console.log("POST", email);
    const response = await axios.post("/api/get_manager", {
      email: email,
    });

    // console.log("Get Work ComId:", response.data);
    return response.data; // Retourne le client token
  } catch (error) {
    console.error("Error when getting worker comId :", error);
    return null;
  }
};

const subscribeToFCMByBackend = (token: string, topic: string[]) => {
  fetch("/api/FCM/subscribe-to-topic", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      token: token,
      topic
    })
  });
}

const subscribeToTopics = async (comId: string, userId: string) => {
  const FCMToken = localStorage.getItem("FCMToken");
  if (FCMToken) {
    const comPostsTopic = `${comId}_posts`;
    const userTopic = userId;
    
    try {
      const alreadySubscribed = await localStorage.getItem('subscribedTopics');
      const subscribed = alreadySubscribed ? JSON.parse(alreadySubscribed) : [];

      const newSubscriptions = [];

      if (!subscribed.includes(comPostsTopic) && !subscribed.includes(userTopic)) {
        await subscribeToFCMByBackend(FCMToken, [comPostsTopic, userTopic]);
        newSubscriptions.push(comPostsTopic);
        newSubscriptions.push(userTopic);
      }

      if (!subscribed.includes(comPostsTopic)) {
        await subscribeToFCMByBackend(FCMToken, [comPostsTopic]);
        newSubscriptions.push(comPostsTopic);
      }

      if (!subscribed.includes(userTopic)) {
        await subscribeToFCMByBackend(FCMToken, [userTopic]);
        newSubscriptions.push(userTopic);
      }

      if (newSubscriptions.length > 0) {
        const updated = Array.from(new Set([...subscribed, ...newSubscriptions]));
        await localStorage.setItem('subscribedTopics', JSON.stringify(updated));
        // console.log("✅ Topics souscrits :", updated);
      }

    } catch (err) {
      console.error("❌ Erreur lors de la souscription aux topics :", err);
    }
  }

  if (isMacOSApp) {
    if (window.webkit?.messageHandlers?.callbackHandler) {
      subscribeToTopicsNative(`${comId}_posts`, userId);
      window.webkit.messageHandlers.callbackHandler.postMessage({ action: "jsReady" });
    }
  }
};

const HomeScreen = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  const userId = AuthUserId;
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  const [locale, setLocale] = useState("en");
  // NAVIGATION
  const location = useLocation();
  const navigate = useNavigate();
  // MACOS APP
  // const { hasToken, token } = await checkMacOsFCMTokenFromNative();
  const [macOsFCMTokenResult, setMacOsFCMTokenResult] = useState<{ hasToken: boolean, token: string | null } | null>(null);
  // TOAST
  const [showToast, setShowToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastTitle, setToastTitle] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [toastUsername, setToastUsername] = useState(false);
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // DATE SERVICES
  const {getTIMEZONE, getSecondNextMonday, getPastDate, getDateNow} = useDateService();
  // const [shiftsTotal, setShiftsTotal] = useState<{ hours: number, minutes: number }>({ hours: 0, minutes: 0 });
  // HOME SETTINGS
  const TIMEZONE = getTIMEZONE();

  const [currentShift, setCurrentShift] = useState<AgendaShift>();
  const [punchColor, setPunchColor] = useState('#CCC');
  const [documentColor, setDocumentColor] = useState('#CCC');
  const [workerColor, setWorkerColor] = useState('#CCC');
  const [newFCMtoken, setNewFCMtoken] = useState<string | undefined>(undefined);
  // const {getFirstComId} = useUserFirstService();
  const [showSchedulerLink, setShowSchedulerLink] = useState(false);
  const [showOpenSchedulerLink, setShowOpenSchedulerLink] = useState(false);

  // Animation
  // const [isOpen1, setIsOpen1] = useState(false);
  // const [isOpen2, setIsOpen2] = useState(false);
  // const isOpen = useRef(false);
  // const slideAnim = useState(new Animated.Value(0))[0];
  // const slideAnim1 = useRef(new Animated.Value(0)).current;
  // const slideAnim2 = useRef(new Animated.Value(0)).current;

  // const navigation = useNavigation<AgendaRouteProp | ShiftRouteProp| CreateShiftRouteProp | 
  //   PostsRouteProp | MapRouteProp | UsersRouteProp | any>();

  const notificationContext = useNotification();
  const postCount = notificationContext?.postCount;
  const shiftCount = notificationContext?.shiftCount;
  const openShiftCount = notificationContext?.openShiftCount;
  const confirmShiftCount = notificationContext?.confirmShiftCount;
  const documentCount = notificationContext?.documentCount;
  const swapRequestCount = notificationContext?.swapRequestCount;
  const leaveRequestCount = notificationContext?.leaveRequestCount;
  // LINK
  const postLink = notificationContext?.postLink;
  const setPostLink = notificationContext?.setPostLink;
  const shiftLink = notificationContext?.shiftLink;
  const setShiftLink = notificationContext?.setShiftLink;
  const openShiftLink = notificationContext?.openShiftLink;
  const setOpenShiftLink = notificationContext?.setOpenShiftLink;
  const confirmShiftLink = notificationContext?.confirmShiftLink;
  const setConfirmShiftLink = notificationContext?.setConfirmShiftLink;

  const [shiftTotal, setShiftTotal] = useState(0);
  const [confirmShiftTotal, setConfirmShiftTotal] = useState(0);
  const [openShiftTotal, setOpenShiftTotal] = useState(0);
  // DATE
  const now = useMemo(() => getDateNow(new Date(), TIMEZONE), []);
  // USER-AGENT
  const userAgent = navigator.userAgent;
  const [permissionStatus, setPermissionStatus] = useState<"default" | "denied" | "granted">(Notification.permission as "default" | "denied" | "granted");
  const {isSafari, isIOS, isSafariOnIOS, requestNotificationPermission} = useHelperService();

  // const date = new Date();
  // date.setDate(date.getDate() - 10); // const date = new Date(Date.now() - 5 * 24 * 60 * 60 * 1000);
  // const tenDaysAgo = date.toISOString().split('T')[0];
  // const date = new Date();
  // date.setDate(date.getDate() - 1);
  // const yesterday = date.toISOString().split('T')[0];

  const {data, loading, error, refetch} = 
    useQuery(getAgendaUser, {variables: {
      userId: userId, 
      startAt: getPastDate(1).split('T')[0], 
      stopAt: getSecondNextMonday(new Date()),
      now: now,
      filter: {suspended: {eq: false}}
    }});

  const [fetchPublicShift, {data: dataPublicShift, loading: loadingPulicShift, error: errorPulicShift, 
    refetch: refetchPulicShift, fetchMore: fetchMorePulicShift}] = 
          useLazyQuery<ShiftAppsByComIdQuery, ShiftAppsByComIdQueryVariables>(shiftAppsByComId);

  const [fetchShiftVerif, {data: dataShiftVerif, loading: loadingShiftVerif, 
          error: errorShiftVerif, refetch: refetchShiftVerif, fetchMore: fetchMoreShiftVerif}] = 
              useLazyQuery<ShiftsByUserQuery, ShiftsByUserQueryVariables>(shiftsByUser);

  // const [fetchPublicShift, {data: dataPublicShift, loading: loadingPulicShift, error: errorPulicShift, 
  //   refetch: refetchPulicShift, fetchMore: fetchMorePulicShift}] = 
  //         useLazyQuery<ShiftAppsByUserQuery, ShiftAppsByUserQueryVariables>(shiftAppsByUser, {variables: {
  //             userId: PUBLIC_ID,
  //             startAt: {gt: getPastDate(1).split('T')[0]},
  //             sortDirection: ModelSortDirection.ASC, 
  //             // limit: SHIFTS_PER_PAGE,
  //             filter: {
  //                 deleted: {ne: true}, 
  //                 confirmed: {ne: true},
  //                 // startAt: {gt: getPastDate(1)},
  //                 and: [
  //                     // {stopAt: {lt: getNextMonday(new Date())}},
  //                     {stopAt: {gt: now}},
  //                 ],
  //                 // stopAt: {lt: getNextMonday(new Date())}
  //             }
  //         }});

  // console.log('start', getPastDate(1).split('T')[0]);
  // console.log('stop', getNextMonday(new Date()));
  const [doUpdateUser, {loading: loadingUpdate, error: errorUpdate}] = 
    useMutation<UpdateAgendaUserMutation, UpdateAgendaUserMutationVariables>(updateAgendaUser); // data: dataUpdate, 

  const [getMyCompany, { data: dataMyCompany, loading: loadingMyCompany }] = useLazyQuery
    <ComByUserIdQuery, ComByUserIdQueryVariables>(comByUserId, {
      variables: { userId: AuthUserId },
  });
  // const resetNotification = (
  //   // setNotif: React.Dispatch<React.SetStateAction<number>> | undefined, 
  //   // notifCount: number | undefined, 
  //   count: number | undefined,
  //   type: string, 
  //   setType: React.Dispatch<React.SetStateAction<number>> | undefined) => {
  //     const unsubscribe = navigation.addListener("focus", () => {
  //       if (typeof setNotificationCount === 'function') {
  //         setNotificationCount((notificationCount ?? 0) - (count ?? 0));
  //       }
  //       updateNotificationModelCount(type, 0); 
  //       if (typeof setType === 'function') {
  //         setType(0);
  //       }
  //   });
    
  //   return unsubscribe;
  // }

  // useFocusEffect(
  //   useCallback(() => {
  //     if (route.params?.refetchUser) {
  //       refetch();
  //       navigation.setParams({ refetchUser: undefined });
  //     }
  //   }, [route.params?.refetchUser])
  // );

  const user = data?.getAgendaUser;

  // when not linked to a company
  // const callForComId = async (email: string, userId: string) => {
  //   const firstComId =  await getFirstComId(email);
  //   // console.log('firstComId: ', firstComId);
  //   if (firstComId && firstComId.comId) {
  //     const confirmedUser = await doUpdateUser({variables: {input: {userId: userId, comId: firstComId.comId}}})
  //     if (confirmedUser && confirmedUser?.data?.updateAgendaUser?.comId) {
  //       refetch();
  //     }
  //   }
  // }

  // const getIOSapnsToken = async () => {
  //    // Récupère le token APNs (uniquement sur un vrai iPhone)
  //    const apnsToken = await messaging().getAPNSToken();
  //    if (apnsToken) {
  //      console.log('APNs Token:', apnsToken);

  //      // Configure l'APNs Token AVANT de récupérer le FCM Token
  //      await messaging().setAPNSToken(apnsToken);
  //    }
  //    messaging().onTokenRefresh((token: any) => {
  //     console.log("🔄 Nouveau FCM Token :", token);
  //   });
  //    messaging().getToken().then((FCMtoken: any) => {
  //      setNewFCMtoken(FCMtoken);
  //    }).catch((error: any) => {
  //      console.error('Erreur de récupération du token FCM:', error);
  //    });
  // }
  useEffect(() => {
    if (location.state?.toastMessage) {
      setToastStatus(location.state.status);
      setToastTitle(location.state.title);
      setToastMessage(location.state.toastMessage);
      setToastUsername(location.state.toastUsername);
      setShowToast(true);

      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]);

  const showNotificationPermission = () => {
    setFooterModal(false);
    setContentModal(
      <>
        <Modal.Header closeButton>
          <Modal.Title>{t('home.safariNotificationTitle')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('home.safariNotificationStatus')} <strong>{permissionStatus}</strong></p>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => {requestNotificationPermission();setShowCustomModal(false);}}>
          {t('home.apply')}
        </Button>
        
      </Modal.Footer>
      </>);
    setShowCustomModal(true);
    // return (
    //     <div style={{ padding: '20px', textAlign: 'center' }}>
    //         <h2>Gérer les Notifications</h2>
    //         <p>Statut actuel de la permission : <strong>{permissionStatus}</strong></p>

    //         {(permissionStatus === 'default' || permissionStatus === 'denied') && (
    //             <button
    //                 onClick={requestNotificationPermission}
    //                 disabled={permissionStatus === 'granted' as typeof permissionStatus}
    //                 style={{
    //                     padding: '10px 20px',
    //                     fontSize: '16px',
    //                     cursor: 'pointer',
    //                     backgroundColor: permissionStatus === 'granted' as typeof permissionStatus ? '#e0e0e0' : '#007bff',
    //                     color: 'white',
    //                     border: 'none',
    //                     borderRadius: '5px'
    //                 }}
    //             >
    //                 {permissionStatus === 'granted' as typeof permissionStatus ? 'Notifications déjà activées' : 'Activer les notifications'}
    //             </button>
    //         )}

    //         {permissionStatus === 'denied' && (
    //             <p style={{ color: 'red', marginTop: '10px' }}>
    //                 Les notifications sont bloquées. Veuillez les activer manuellement dans les paramètres de votre navigateur.
    //             </p>
    //         )}
    //     </div>
    // );
  }

  const verifySafariPermission = () => {
    setPermissionStatus(Notification.permission);
    if ('Notification' in window) {
      if (Notification.permission === 'default') showNotificationPermission();
    } else if (isSafari()) {
      if (Notification.permission === 'default') showNotificationPermission();
    } else if (isSafariOnIOS()) {
      if (Notification.permission === 'default') showNotificationPermission();
    } else if (isIOS()) {
      if (Notification.permission === 'default') showNotificationPermission();
    }
  }

  useEffect(() => {
    if (!isMacOSApp) {
      verifySafariPermission();
    }
  }, []);

  const getPublicShifts = async () => {
    await fetchPublicShift({variables: {
        comId: user?.comId,
        startAt: {gt: getPastDate(1).split('T')[0]},
        sortDirection: ModelSortDirection.ASC, 
        // limit: SHIFTS_PER_PAGE,
        filter: {
            userId: {eq: PUBLIC_ID},
            deleted: {ne: true}, 
            accepted: {ne: true},
            confirmed: {ne: true},
            // startAt: {gt: getPastDate(1)},
            and: [
                // {stopAt: {lt: getNextMonday(new Date())}},
                {stopAt: {gt: now}},
            ],
            // stopAt: {lt: getNextMonday(new Date())}
        }
    }});
  }

  const getVerifShifts = async () => {
      await fetchShiftVerif({variables: {
          userId: userId,
          startAt: {gt: getPastDate(1).split('T')[0]},
          sortDirection: ModelSortDirection.ASC, 
          // limit: SHIFTS_PER_PAGE,
          filter: {
              deleted: {ne: true}, 
              accepted: {eq: true},
              // confirmed: {ne: true},
              // startAt: {gt: getPastDate(1)},
              and: [
                  // {stopAt: {lt: getNextMonday(new Date())}},
                  {stopAt: {gt: now}},
              ],
              // stopAt: {lt: getNextMonday(new Date())}
          }
          // filter: {accepted: {ne: true}, deleted: {ne: true}}//{attributeExists: false}, deleted: {attributeExists: false}} //ne: true ...not working here but in appsync yes
      }});
  }

  useEffect(() => {
    if (!user) return;
    if (!user.email) return;
    if (user) {
      if (!user.comId && user.email) {
        const getWorker = async () => {
          const workerComId = await getComId(user.email);
          // console.log("workerComId", workerComId);
          if (workerComId.comId) {
            await doUpdateUser({variables: {input: {userId: user.userId, comId: workerComId.comId}}})
            window.location.reload();
          } else {
            if (user.email && user.type === "EMPLOYEE") {
              navigate('/?missingCompanyLink');
            } else if (user.type === "MANAGER") {
              navigate(t('link.create_company'), { state: { status: "bg-info", title: "", toastMessage: t('toast.companyNeeded') }});
            }
          }
        }
        const callManager = async () => {
          let wait = false;
          if (!user.comId) {
            if (user.email && user.type === "EMPLOYEE") {
              const resManager = await getManager(user.email);
              // console.log('res', resManager);
              if (resManager?.type === "admin") {
                await doUpdateUser({variables: {input: {userId: user.userId, type: AgendaUserType.MANAGER}}});
                wait = true;
                navigate(t('link.create_company'));
              }
              if (resManager?.type === "MANAGER") {
                const workerComId = await getComId(user.email);
                if (!workerComId.comId) {
                  await doUpdateUser({variables: {input: {userId: user.userId, type: resManager.type}}});
                } else {
                  await doUpdateUser({variables: {input: {userId: user.userId, comId: workerComId.comId}}});
                  window.location.reload();
                }
                wait = true;
                navigate(t('link.create_company'));
              }
            }
          }
          return wait;
        }
        (async () => {
          await getMyCompany();
          const wait = await callManager();
          if (!wait) {
            await getWorker();
          }
        })();
      }
      setLocale(user?.language);
      getPublicShifts();
      getVerifShifts();
      subscribeToTopics(user.comId, user.userId);
      setShiftTotal(user?.job?.items?.length);
      //setOpenShiftTotal(user?.shiftApps?.items?.length);
      setConfirmShiftTotal(user?.shifts?.items?.length);
    }
  }, [user]);

  const myCompany = dataMyCompany?.comByUserId?.items
  const publicShift = dataPublicShift?.shiftAppsByComId?.items || [];
  const verifShifts = dataShiftVerif?.shiftsByUser?.items || [];

  const mergedShifts = useMemo(() => {
      return [
          ...publicShift.filter(s =>
              !verifShifts.some(v => v?.shiftAppId === s?.shiftAppId)
          )
      ];
  }, [verifShifts, publicShift]);


  useEffect(() => {
    if (user && myCompany) {
      // console.log('comp', myCompany)
      if (!user.comId && myCompany.length > 0) {
        doUpdateUser({variables: {input: {userId: user.userId, comId: myCompany[0].comId}}})
      } 
    }
  }, [myCompany]);

  useEffect(() => {
    if (!user) return;
    if (!user.email) return;
    if (user) {
      if (user.comId && user.email) {
        setShiftTotal(user?.job?.items?.length + shiftCount);
        // setOpenShiftTotal(user?.shiftApps?.items?.length + mergedShifts.length + openShiftCount)
        setOpenShiftTotal(mergedShifts.length + openShiftCount)
        setConfirmShiftTotal(user?.shifts?.items?.length + confirmShiftCount)
      }
    }

  }, [shiftCount, openShiftCount, confirmShiftCount]); // publicShift]); // mergedShifts

  useEffect(() => {
    setOpenShiftTotal(mergedShifts.length)
  }, [mergedShifts]);

  // useEffect(() => {
  //   if (user) {
  //     if (!user.FCMtoken ) {
  //       doUpdateUser({variables: {input: {userId: user.userId, FCMtoken: newFCMtoken}}});
  //     } else if (user.FCMtoken != newFCMtoken) {
  //       // console.log('ok1', newFCMtoken);
  //       doUpdateUser({variables: {input: {userId: user.userId, FCMtoken: newFCMtoken}}});
  //     }
  //   }
  // }, [newFCMtoken]);

  const orderedShifts = useMemo(() => {
    if (!data?.getAgendaUser?.shifts?.items) return [];
    
    return [...data.getAgendaUser.shifts.items].sort((a, b) => 
      new Date(a.startAt).getTime() - new Date(b.startAt).getTime()
    );
  }, [data]);

  const getCurrentShift = (usr: any) => {

    // console.log("getCurrentShift ", user.shifts.items[0]);
    // console.log(new Date(user.shifts.items[0].stopAt).getTime());
    // console.log(new Date().getTime());
    if (orderedShifts[0]) {
      // console.log("getCurrentShift ", user.shifts.items[0]);
      // console.log("test", new Date(user.shifts.items[0].startAt).getTime());
      if (new Date(new Date(orderedShifts[0].stopAt).setHours(new Date(orderedShifts[0].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
        // console.log("getCurrentShift ", user.shifts.items[0]);
        if (new Date(new Date(orderedShifts[0].stopAt).setHours(new Date(orderedShifts[0].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
          // console.log("getCurrentShift ", user.shifts.items[0]);
          setCurrentShift(orderedShifts[0]);
        } else if (orderedShifts[1]) {
          if (new Date(orderedShifts[1].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
            if (new Date(new Date(orderedShifts[1].stopAt).setHours(new Date(orderedShifts[1].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
              // console.log("getCurrentShift1 ", user.shifts.items[1]);
              setCurrentShift(orderedShifts[1]);
            } else if (orderedShifts[2]) {
              if (new Date(orderedShifts[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
                if (new Date(new Date(orderedShifts[2].stopAt).setHours(new Date(orderedShifts[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
                  // console.log("getCurrentShift2 ", user.shifts.items[2]);
                  setCurrentShift(orderedShifts[2]);
                }
              }
            }
          }
        }
      } else if (orderedShifts[1]) {
        if (new Date(orderedShifts[1].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
          if (new Date(new Date(orderedShifts[1].stopAt).setHours(new Date(orderedShifts[1].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
            // console.log("getCurrentShift11 ", user.shifts.items[1]);
            setCurrentShift(orderedShifts[1]);
          } else if (orderedShifts[2]) {
            if (new Date(orderedShifts[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
              if (new Date(new Date(orderedShifts[2].stopAt).setHours(new Date(orderedShifts[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
                // console.log("getCurrentShift22 ", user.shifts.items[2]);
                setCurrentShift(orderedShifts[2]);
              }
            }
          }
        }  else if (orderedShifts[2]) {
          if (new Date(orderedShifts[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
            if (new Date(new Date(orderedShifts[2].stopAt).setHours(new Date(orderedShifts[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
              // console.log("getCurrentShift22", orderedShifts[2]);
              setCurrentShift(orderedShifts[2]);
            }
          }
        }
      }  else if (orderedShifts[2]) {
        if (new Date(orderedShifts[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
          if (new Date(new Date(orderedShifts[2].stopAt).setHours(new Date(orderedShifts[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
            // console.log("getCurrentShift222", orderedShifts[2]);
            setCurrentShift(orderedShifts[2]);
          }
        }
      }
    } else {
      setCurrentShift(null);
    }
  }

  // const getCurrentShift = (usr: any) => {

  //   // console.log("getCurrentShift ", user.shifts.items[0]);
  //   // console.log(new Date(user.shifts.items[0].stopAt).getTime());
  //   // console.log(new Date().getTime());
  //   console.log("currentShift", user?.shifts.items);
  //   if (user?.shifts.items[0]) {
  //     // console.log('TIMEZONE',new Date(new Date(user.shifts.items[0].stopAt).setHours(new Date(user.shifts.items[0].stopAt).getHours() - TIMEZONE)));
  //     // console.log("getCurrentShift ", user.shifts.items[0]);
  //     if (new Date(new Date(user.shifts.items[0].stopAt).setHours(new Date(user.shifts.items[0].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
  //       // console.log("getCurrentShift ", user.shifts.items[0]);
  //       if (new Date(new Date(user.shifts.items[0].stopAt).setHours(new Date(user.shifts.items[0].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
  //         // console.log("getCurrentShift ", user.shifts.items[0]);
  //         setCurrentShift(user.shifts.items[0]);
  //       } else if (user?.shifts.items[1]) {
  //         if (new Date(user.shifts.items[1].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
  //           if (new Date(new Date(user.shifts.items[1].stopAt).setHours(new Date(user.shifts.items[1].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
  //             // console.log("getCurrentShift1 ", user.shifts.items[1]);
  //             setCurrentShift(user.shifts.items[1]);
  //           } else if (user?.shifts.items[2]) {
  //             if (new Date(user.shifts.items[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
  //               if (new Date(new Date(user.shifts.items[2].stopAt).setHours(new Date(user.shifts.items[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
  //                 // console.log("getCurrentShift2 ", user.shifts.items[2]);
  //                 setCurrentShift(user.shifts.items[2]);
  //               }
  //             }
  //           }
  //         }
  //       }
  //     } else if (user?.shifts.items[1]) {
  //       if (new Date(user.shifts.items[1].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
  //         if (new Date(new Date(user.shifts.items[1].stopAt).setHours(new Date(user.shifts.items[1].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
  //           // console.log("getCurrentShift11 ", user.shifts.items[1]);
  //           setCurrentShift(user.shifts.items[1]);
  //         } else if (user?.shifts.items[2]) {
  //           if (new Date(user.shifts.items[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
  //             if (new Date(new Date(user.shifts.items[2].stopAt).setHours(new Date(user.shifts.items[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
  //               // console.log("getCurrentShift22 ", user.shifts.items[2]);
  //               setCurrentShift(user.shifts.items[2]);
  //             }
  //           }
  //         }
  //       }  else if (user?.shifts.items[2]) {
  //         if (new Date(user.shifts.items[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
  //           if (new Date(new Date(user.shifts.items[2].stopAt).setHours(new Date(user.shifts.items[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
  //             // console.log("getCurrentShift22", user.shifts.items[2]);
  //             setCurrentShift(user.shifts.items[2]);
  //           }
  //         }
  //       }
  //     }  else if (user?.shifts.items[2]) {
  //       if (new Date(user.shifts.items[2].startAt).getTime() > (new Date().getTime() - (24*(60*60000))) ) {
  //         if (new Date(new Date(user.shifts.items[2].stopAt).setHours(new Date(user.shifts.items[2].stopAt).getHours() - TIMEZONE)).getTime() > (new Date().getTime())) {
  //           // console.log("getCurrentShift222", user.shifts.items[2]);
  //           setCurrentShift(user.shifts.items[2]);
  //         }
  //       }
  //     }
  //   }
  // }

  useEffect(() => {
    if (user) {
      getCurrentShift(user);
    }
  }, [user]);

  // useEffect(() => {
  //   console.log('postCount mis à jour:', postCount);
  // }, [postCount]);

  // Apollo
  if (loading) {
    return (
      <div className="spinnerContainer">
          <Spinner animation="border" role="status" className="spinner">
              <span className="visually-hidden">Loading...</span>
          </Spinner>   
      </div>
    )
  };
  
  if (error || !user) {
    if (error.networkError && typeof (error.networkError as NetworkErrorWithStatusCode).statusCode === 'number') {
      // TypeScript sait maintenant que error.networkError a un statusCode de type number
      const httpStatusCode = (error.networkError as NetworkErrorWithStatusCode).statusCode;
      // console.log("Statut HTTP de l'erreur réseau:", httpStatusCode);

      if (httpStatusCode === 401) {
        // console.log("Erreur 401 détectée : Rechargement de la page pour rafraîchir l'authentification.");
        window.location.reload();
      }
    }
    return (
      <div className="users-container flex-grow-1 p-3">
        <h3>Error fetching the user</h3>
        <p>{error?.message || "User not found"}</p>
        <Link to="" onClick={() => window.location.reload()}>Reload</Link>
      </div>
    );
  };

  // if (!user.comId) {
  //   return (
  //     <div className="spinnerContainer">
  //         <Spinner animation="border" role="status" className="spinner">
  //             <p className="visually-hidden">{t('home.linkedCompany')}</p>
  //         </Spinner>   
  //     </div>
  //   )
  // };

  if(user.suspended == true) {
    alert(t('home.beenSuspended'));
  }

  const getLanguage = () => {
    switch (savedLang) {
      case 'en':
        return enUS
      case 'fr':
        return fr
      default:
        return enUS
    }
  }

  const applyOnPunch = () => {
    setFooterModal(false);
    setContentModal(
      <>
        <Modal.Header closeButton>
          <Modal.Title>{t('home.wantToPunchTitle')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('home.wantToPunch')}</p>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
          Cancel
        </Button>
        <Button variant="primary" onClick={goToMap}>
          {t('home.apply')}
        </Button>
      </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

  const goToMap = () => {
      setPunchColor('#CCC');
      navigate(`${t('link.map')}${currentShift?.shiftId}`);
      // navigate('Map', {userId: user.userId, shiftId: currentShift?.shiftId});
  }

  const goToUsers = () => {
    const navToUsers = () => {
      setWorkerColor('#CCC');
      navigate(t('link.users'));
    }
    setWorkerColor("#11947e");
    setTimeout(navToUsers, 200);
  }

  const createPunch = () => {
    // setPunchColor("#11947e");
    // Geolocation.getCurrentPosition(info => console.log("GPS", info));
    if (currentShift) {
      if (currentShift.startAt && (new Date(currentShift.startAt).getTime() - (30*60000)) < new Date().getTime() ) {
        applyOnPunch();
      } else {
        setContentModal(
          <>
            <Modal.Header closeButton>
              <Modal.Title>{t('home.shiftToFarTitle')}</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
              <p>{t('home.shiftToFar')}</p>
            </Modal.Body>
          </>);
        setShowCustomModal(true);
      }
    } else {
      setContentModal(
        <>
          <Modal.Header closeButton>
            <Modal.Title>{t('home.notWorkingTitle')}</Modal.Title>
          </Modal.Header>
  
          <Modal.Body>
            <p>{t('home.notWorking')}</p>
          </Modal.Body>
        </>);
      setShowCustomModal(true);
    } 
    // setPunchColor("#CCC");
  }

  const applyOnDoccument = () => {
    setFooterModal(false);
    setContentModal(
      <>
        <Modal.Header closeButton>
          <Modal.Title>{t('home.uploadDocTitle')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('home.uploadDoc')}</p>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
          Cancel
        </Button>
        { user.type === "MANAGER" &&
          <Button variant="primary" onClick={goToDocumentsManager}>
            {t('home.goToDocManager')}
          </Button>
        }
        <Button variant="primary" onClick={goToDocuments}>
          {t('home.goToDoc')}
        </Button>
      </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

  const chooseRequestType = () => {
    setFooterModal(false);
    setContentModal(
      <>
        <Modal.Header closeButton>
          <Modal.Title>{t('request.chooseTitle')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('request.chooseMessage')}</p>
        </Modal.Body>
        <Modal.Footer>
        <Col>
          <Button className="mt-2 w-100" variant="primary" onClick={() => navigate(t('link.leave_create'))}>
            {t('request.createLeaveTab')}
          </Button>
          <Button className="mt-2 w-100" variant="primary" onClick={() => navigate(t('link.requests_leave'))}>
            {t('request.leaveTab')}
          </Button>
          <Button className="mt-2 w-100" variant="primary" onClick={() => navigate(t('link.requests_swap'))}>
            {t('request.swapLink')}
          </Button>
          { user.type === "EMPLOYEE" &&
            <Button className="mt-2 w-100" variant="secondary" onClick={() => setShowCustomModal(false)}>
              Cancel
            </Button>
          }
        </Col>
        { user.type === "MANAGER" &&
          <>
            <Col>
              <Button className="mt-2 w-100" variant="danger" onClick={() => navigate(t('link.swap_management'))}>
                {t('request.swapManagerLink')}
              </Button>
              <Button className="mt-2 w-100" variant="danger" onClick={() => navigate(t('link.leave_management'))}>
                {t('request.askManagerLink')}
              </Button>
              <Button className="mt-2 w-100" variant="secondary" onClick={() => setShowCustomModal(false)}>
                Cancel
              </Button>
            </Col>
          </>
        }
      </Modal.Footer>
      </>);
    setShowCustomModal(true);
  };

  const createDocument = () => {
    // setDocumentColor("#11947e");
    applyOnDoccument();
  }

  // const goToAgenda = () => {
  //   // navigation.navigate('Agenda', {refetchShift: true});
  //   navigate('Agenda');
  // }

  // const goToAgenda = () => {
  //   if (confirmShiftLink || (user.type === "MANAGER" && shiftLink)) {
  //     navigate('/agenda');
  //     // navigation.navigate('Agenda', {refetchShift: true, givenDate: confirmShiftLink});
  //   } else {
  //     navigate('/agenda');
  //     // navigation.navigate('Agenda', {refetchShift: true});
  //   }
  //   // navigation.navigate('Agenda', {screen:"Agenda", initial: false});
  // }

  // const goToAgendaManager = () => {
  //   navigate('AgendaManager');
  // }

  // const goToTimeLine = () => {
  //   navigate('TimeLine');
  // }

  const goToOpenShift = () => {
    window.location.href = '/open_shifts';
    // if (openShiftLink && openShiftLink != "") {
    //     if (openShiftLink == PUBLIC_ID) {
    //       // navigate('/open_shifts/public');
    //       window.location.href = '/open_shifts/public';
    //     } else {
    //       // navigate('/open_shifts');
    //       window.location.href = '/open_shifts';
    //     }
    // } else {
    //   // navigate('/open_shifts');
    //   window.location.href = '/open_shifts';
    // }
  }

  // const goToOpenShiftManager = () => {
  //   navigate('AgendaOpenManager');
  // }

  // const goToCreateOpenShift = () => {
  //   navigate('CreateOpenShift');
  // }

  // const goToShift = (id: string) => {
  //   // navigate(t('link.shift') + '/' + id);
  // }
  const goToShiftDetail = (id: string) => {
    navigate(t('link.shift') + '/' + id, { state: { refetchData: true } });
  }

  // const goToCreateShift = () => {
  //   navigate('CreateShift');
  // }

  // const goToNewsFeed = () => {
  //   // console.log('test')
  //     // navigate('/posts'); //, comId: user.comId, readedAt: user.readedAt}
  //   navigate('/posts', { replace: true, state: {} });
  // }

  const goToNewsFeed = () => {
    if (postLink && postLink != "") {
      // navigate(`/posts/${postLink}`, { replace: true, state: {} });
      window.location.href = `/posts/${postLink}`;
    } else {
      // navigate('/posts', { replace: true, state: {} });
      window.location.href = '/posts';
    }
  }

  const goToDocuments = () => {
    // setDocumentColor("#CCC");
    // alert("Coming Soon");
    navigate(`${t('link.worker')}/documents`); //, comId: user.comId, readedAt: user.readedAt}
  }

  const goToDocumentsManager = () => {
    // setDocumentColor("#CCC");
    // alert("Coming Soon");
    navigate('/documents'); //, comId: user.comId, readedAt: user.readedAt}
  }

  const goToRequestsManager = () => {
    chooseRequestType();
  }

  const truncate = (str: string | undefined, maxlength: number) => {
    if (str) {
      return (str.length > maxlength) ?
      str.slice(0, maxlength - 1) + '…' : str;
    } else {
      return str;
    }
  };

  // const confirmShiftAnimation = () => {
  //   // console.log(isOpen.current == true);
  //   // Déclenche l'animation de glissement
  //   setIsOpen1(!isOpen1);
  //   Animated.timing(slideAnim1, {
  //     toValue: isOpen1 ? 0 : 25, // Glissement vers le bas ou vers le haut
  //     duration: 300, // Durée de l'animation
  //     useNativeDriver: true, // Utilise le driver natif pour une meilleure performance
  //   }).start();
  //     // }).start(() => setIsOpen(prevState => !prevState));

  //   // isOpen.current = !isOpen.current;
  //   // setIsOpen(prevState => !prevState);
  //   // onPress(); // Appelle la fonction onPress passée en props
  // };

  // const opacityAnim1 = slideAnim1.interpolate({
  //   inputRange: [0, 1],
  //   outputRange: [0, 1], // 0 = invisible, 1 = totalement visible
  // });

  // const openShiftAnimation = () => {
  //   setIsOpen2(!isOpen2);
  //   Animated.timing(slideAnim2, {
  //     toValue: isOpen2 ? 0 : 25,
  //     duration: 300,
  //     useNativeDriver: true,
  //   }).start();
  // };

  // const opacityAnim2 = slideAnim2.interpolate({
  //   inputRange: [0, 1],
  //   outputRange: [0, 1], // 0 = invisible, 1 = totalement visible
  // });

  // test on SIMULATOR
  // const simulateIOSnotif = async () => {
  //   const messa = {
  //     "Simulator Target Bundle": "com.apple.Preferences",
  //     "aps": {
  //         "alert": "This is a simulated notification!",
  //         "badge": 1,
  //         "sound": "default"
  //     }
  //   }

  //   const channelId = await notifee.createChannel({
  //     // id: message.notification.android.channelId,
  //     id: 'schedulum_channel', // "default", // "schedulum_channel",
  //     name: 'Schedulum Channel',
  //     // importance: AndroidImportance.HIGH,
  //   });

  //   await notifee.displayNotification({
  //     title: "Title",
  //     body: "Body",
  //     ios: {
  //       sound: 'default',
  //     },
  //   });
  // }
  // const toggleSchedulerLink = (e: React.MouseEvent) => {
  //   e.preventDefault(); // Empêche le Link d'aller vers "/agenda"
  //   setShowSchedulerLink(prev => !prev);
  // };
  const toggleSchedulerLink = () => {
    setShowSchedulerLink(prev => !prev);
  };

  const toggleOpenSchedulerLink = () => {
    setShowOpenSchedulerLink(prev => !prev);
  };

  const startAt = currentShift && currentShift?.startAt ? new Date(currentShift.startAt) : new Date();
  startAt.setHours(startAt.getHours() - TIMEZONE);
  const stopAt = currentShift && currentShift?.stopAt ? new Date(currentShift.stopAt) : new Date();
  stopAt.setHours(stopAt.getHours() - TIMEZONE);
  
  // console.log('SHIFTS', user.shifts)
  return (
    <>
      <CustomModal
          show={showCustomModal}
          onHide={() => setShowCustomModal(false)}
          link={linkModal}
          children={contentModal}
          isFooter={footerModal}
      />

      <ToastContainer className="p-3 toastTop">
        <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide className={`${toastStatus}`}>
          { toastTitle != "" &&
            <Toast.Header className={`text-center ${toastStatus}`}>
              <strong className="mx-auto text-white-50 text-center">{toastTitle}</strong>
            </Toast.Header>
          }
          <Toast.Body className="text-center"><strong className="mx-auto text-white text-center">{toastMessage}{toastUsername ? ' ' + user?.username : ''}</strong></Toast.Body>
        </Toast>
      </ToastContainer>
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
            <Container fluid className="py-4" style={{ minHeight: '100vh' }}>
              {/* Header Section */}
              { user?.type === "MANAGER" ? (
                <>
                  {user?.com &&
                    user.userId == user?.com?.userId ?
                      <h4 style={{ textAlign: 'center' }}>
                        <Link to={`${t('link.company')}/${user.com.comId}`} style={{fontWeight: 'bold'}}>
                          <CompanyLogo comId={user.comId} name={user?.com.name} customClass="comLogo_md" onlyImage={true} />
                        </Link>
                      </h4>
                    :
                      user?.com &&
                        <h4 style={{ textAlign: 'center' }}><CompanyLogo comId={user.comId} name={user?.com.name} customClass="comLogo_md" onlyImage={true} /></h4>
                  }
                  <Card className="shadow-sm mb-4">
                    <Card.Body>
                    { user?.com ? (
                        <>
                          <Col xs="auto">
                            {user.com.account_type !== "" ? (
                              <>
                               {/* <Link to={`${t('link.company')}/${user.com.comId}`} style={{fontWeight: 'bold'}}>
                                  <Row className="dashboard_row text-secondary align-items-center">
                                    <Col>
                                      <CompanyLogo comId={user.comId} name={user.com.name} customClass="comLogo_sm" onlyImage={true} />
                                    </Col>
                                  </Row>
                                </Link> */}
                                <Link id="scheduler-trigger" to={t('link.add_worker')} className="dashboard_row_link">
                                  <Row className="dashboard_row text-secondary align-items-center">
                                  {/* <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light"> */}
                                    <Col>
                                      <FaUsers className="dashboard_row_link_icon text-secondary me-2" />
                                      <span className="dashboard_row_link text-secondary fw-bold">{t('profile.add_worker')}</span>
                                    </Col>
                                  </Row>
                                </Link>
                                { user.userId == user?.com?.userId ?
                                  !isMacOSApp &&
                                    <Link to={t('link.billing')} className="dashboard_row_link">
                                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                                        <Col>
                                          <FaCreditCard className="dashboard_row_link_icon text-secondary me-2" />
                                          <span className="dashboard_row_link text-secondary fw-bold">{t('profile.change_plan')}</span>
                                        </Col>
                                      </Row>
                                    </Link>
                                :
                                  !isMacOSApp &&
                                    <a onClick={() => navigate(t('link.dashboard'), { state: { status: "bg-danger", title: t("toast.companyRestrictedTitle"), toastMessage: t('toast.companyRestricted')}})} className="dashboard_row_link">
                                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                                        <Col>
                                          <FaCreditCard className="dashboard_row_link_icon text-secondary me-2" />
                                          <span className="dashboard_row_link text-secondary fw-bold">{t('profile.change_plan')}</span>
                                        </Col>
                                      </Row>
                                    </a>
                                }
                                {/* <Link to={t('link.add_worker')}>{t('profile.add_worker')}</Link><br/>
                                <Link to={t('link.billing')}>{t('profile.change_plan')}</Link> */}
                              </>
                            ) : (
                              isMacOSApp ?
                                <Link to="" className="dashboard_row_link">
                                  <Row className="dashboard_row text-secondary align-items-center">
                                    <Col>
                                      <FaCartShopping className="dashboard_row_link_icon text-secondary me-2" />
                                      <span className="dashboard_row_link text-secondary fw-bold">{t('profile.choose_plan_MACOS')}</span>
                                    </Col>
                                  </Row>
                                </Link>
                              :
                                <Link to={t('link.billing')} className="dashboard_row_link">
                                  <Row className="dashboard_row text-secondary align-items-center">
                                    <Col>
                                      <FaCartShopping className="dashboard_row_link_icon text-secondary me-2" />
                                      <span className="dashboard_row_link text-secondary fw-bold">{t('profile.choose_plan')}</span>
                                    </Col>
                                  </Row>
                                </Link>
                                // <Link to={t('link.billing')}>{t('profile.choose_plan')}</Link>
                            )}
                          </Col>
                        </>
                      ) : (
                        <Link to={t('link.create_company')}>{t('profile.create_company')}</Link>
                      )}
                    </Card.Body>
                  </Card>
                </>
              ) : (
                user?.com &&
                  <h4 style={{ textAlign: 'center' }}><CompanyLogo comId={user.comId} name={user?.com.name} customClass="comLogo_md" onlyImage={true} /></h4>
              )}

              <Card className="shadow-sm mb-4">
                <Card.Body>
                  {currentShift ? (
                    <Row className="align-items-center">
                      <Col>
                        <h5 className="fw-bold">{t('home.currentShift')}</h5>
                        <p className="mb-1">{currentShift.role}</p>
                        <p className="mb-1">{currentShift.location}</p>
                        <p style={{fontSize: 10, marginBottom: 3}}>{t('shift.startAt')}{format(startAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                        <p style={{fontSize: 10}}>{t('shift.stopAt')}{format(stopAt, "EEEE d MMMM, HH:mm", {locale: getLanguage()})}</p>
                        <p className="mb-1">
                          {/* Débute à : {dayjs.utc(currentShift.startAt).format('D MMM YYYY, HH:mm')} */}
                        </p>
                        <p className="mb-0">
                          {/* Finit à : {dayjs.utc(currentShift.stopAt).format('D MMM YYYY, HH:mm')} */}
                        </p>
                      </Col>
                      <Col xs="auto">
                        <div className="flex-grow-2">
                          <IoArrowRedoCircleOutline onClick={() => goToShiftDetail(currentShift.shiftId)} className="hover-icon" size={80}/>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="align-items-center mt-2">
                      <Col>
                        <h5 className="fw-bold">{user?.username}</h5>
                        <p>{t('home.no_shift')}</p>
                      </Col>
                      <Col xs="auto">
                        {/* <UserImage /> ou img avec user.avatar */}
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>

              
              <Card className="shadow-sm mb-4">
                { user.type === "MANAGER" && 
                  <Card.Body>
                    <Link id="scheduler-trigger" to="" className="dashboard_row_link" onClick={toggleSchedulerLink}>
                      <Row className="dashboard_row text-secondary align-items-center">
                        <Col>
                          <FaCalendarCheck className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.upcomingShift')}</span>
                          <FaArrowTurnDown />
                        </Col>
                        <Col xs="auto" style={showSchedulerLink ? {display: 'none'} : {display: 'block'}}>
                          { confirmShiftCount && confirmShiftCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {confirmShiftTotal}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {user?.shifts?.items?.length}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                    {/* <Link id="scheduler-link" to={t('link.scheduler')} className="dashboard_row_link"> */}
                    {/* <Link id="scheduler-link" to={t('link.scheduler')} className={`dashboard_row_link transition-collapse ${showSchedulerLink ? 'show' : 'hide'}`}>
                    <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                      <Col>
                        <FaUserTie size={30} className="dashboard_row_link text-secondary me-2" />
                        <span className="dashboard_row_link text-secondary fw-bold">{t('home.manageShift')}</span>
                      </Col>
                    </Row>
                    </Link> */}
                    {showSchedulerLink && (
                      <div className="collapse-slide">
                        <Link to="/agenda" className="dashboard_row_link">
                          <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                            <Col>
                              <FaCalendarCheck className="user-agenda-icon dashboard_row_link_icon text-secondary me-2" />
                              <span className="dashboard_row_link text-secondary fw-bold">{t('home.upcomingShift')}</span>
                            </Col>
                            <Col xs="auto" style={showSchedulerLink ? {display: 'block'} : {display: 'none'}}>
                              { confirmShiftCount && confirmShiftCount > 0 ?
                                <Badge pill bg="danger" className="badge-notif">
                                  {confirmShiftTotal}
                                  <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                                </Badge>
                              :
                                <Badge pill bg="secondary">
                                  {user?.shifts?.items?.length}
                                </Badge>
                              }
                            </Col>
                          </Row>
                        </Link>
                        <Link id="scheduler-link" to={t('link.scheduler')} onClick={() => setShowSchedulerLink(false)} className="dashboard_row_link">
                          <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                            <Col>
                              <FaUserTie className="user-tie-icon dashboard_row_link_icon text-secondary me-2" />
                              <span className="dashboard_row_link text-secondary fw-bold">{t('home.manageShift')}</span>
                            </Col>
                          </Row>
                        </Link>
                      </div>
                    )}
                    <Link id="open-scheduler-trigger" to="" className="dashboard_row_link" onClick={toggleOpenSchedulerLink}>
                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                        <Col>
                        <FaPaperPlane className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.openShift')}</span>
                          <FaArrowTurnDown />
                        </Col>
                        <Col xs="auto" style={showOpenSchedulerLink ? {display: 'none'} : {display: 'block'}} id="open-shift-notif-container">
                          { openShiftCount && openShiftCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {openShiftTotal}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {/* {user?.shiftApps?.items?.length + mergedShifts.length} */}
                              {mergedShifts.length}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                    {showOpenSchedulerLink && (
                      <div className="collapse-slide">
                        <Link to="" onClick={goToOpenShift} className="dashboard_row_link">
                          <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                            <Col>
                              <FaPaperPlane className="user-openshift-icon dashboard_row_link_icon text-secondary me-2" />
                              <span className="dashboard_row_link text-secondary fw-bold">{t('home.openShiftAvail')}</span>
                            </Col>
                            <Col xs="auto" style={showOpenSchedulerLink ? {display: 'block'} : {display: 'none'}}>
                              { openShiftCount && openShiftCount > 0 ?
                                <Badge pill bg="danger" className="badge-notif">
                                  {openShiftTotal}
                                  <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                                </Badge>
                              :
                                <Badge pill bg="secondary">
                                  {/* {user?.shiftApps?.items?.length + mergedShifts.length} */}
                                  {mergedShifts.length}
                                </Badge>
                              }
                            </Col>
                          </Row>
                        </Link>
                        <Link id="open-scheduler-link" to={`${t('link.scheduler')}${t('link.open_shifts')}`} onClick={() => setShowOpenSchedulerLink(false)} className="dashboard_row_link">
                          <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                            <Col>
                              <FaUserTie className="user-tie-icon dashboard_row_link_icon text-secondary me-2" />
                              <span className="dashboard_row_link text-secondary fw-bold">{t('home.manageOpenShift')}</span>
                            </Col>
                          </Row>
                        </Link>
                      </div>
                    )}
                    <Link to={t('link.shifts')} className="dashboard_row_link">
                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                        <Col>
                          <MdNewReleases className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.shiftReceived')}</span>
                        </Col>
                        <Col xs="auto">
                          { shiftCount && shiftCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {shiftTotal}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {user?.job?.items?.length}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                    <Link to={postLink && postLink != "" ? `${t('link.posts')}/${postLink}`: `${t('link.posts')}`} className="dashboard_row_link">
                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                        <Col>
                          <IoIosMegaphone className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.newsFeed')}</span>
                        </Col>
                        <Col xs="auto">
                          { postCount && postCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {postCount}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {postCount}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                  </Card.Body>
                }
                { user.type === "EMPLOYEE" && 
                  <Card.Body>
                    <Link to="/agenda" className="dashboard_row_link">
                      <Row className="dashboard_row text-secondary align-items-center">
                        <Col>
                          <FaCalendarCheck className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.upcomingShift')}</span>
                        </Col>
                        <Col xs="auto">
                          { confirmShiftCount && confirmShiftCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {confirmShiftTotal}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {user?.shifts?.items?.length}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                    <Link to="" onClick={goToOpenShift} className="dashboard_row_link">
                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                        <Col>
                        <FaPaperPlane className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.openShiftAvail')}</span>
                        </Col>
                        <Col xs="auto">
                          { openShiftCount && openShiftCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {openShiftTotal}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {/* {user?.shiftApps?.items?.length + publicShift.length} */}
                              {publicShift.length}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                    <Link to={t('link.shifts')} className="dashboard_row_link">
                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                        <Col>
                          <MdNewReleases className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.shiftReceived')}</span>
                        </Col>
                        <Col xs="auto">
                          { shiftCount && shiftCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {shiftTotal}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {user?.job?.items?.length}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                    <Link to={t('link.posts')} className="dashboard_row_link">
                      <Row className="dashboard_row text-secondary align-items-center mt-2 pt-2 border-top border-1 border-light">
                        <Col>
                          <IoIosMegaphone className="dashboard_row_link_icon text-secondary me-2" />
                          <span className="dashboard_row_link text-secondary fw-bold">{t('home.newsFeed')}</span>
                        </Col>
                        <Col xs="auto">
                          { postCount && postCount > 0 ?
                            <Badge pill bg="danger" className="badge-notif">
                              {postCount}
                              <MdFiberNew size={20} color="maroon" style={{position: 'absolute', top:-15, right: -15}}/>
                            </Badge>
                          :
                            <Badge pill bg="secondary">
                              {postCount}
                            </Badge>
                          }
                        </Col>
                      </Row>
                    </Link>
                  </Card.Body>
                }
              </Card>

              {/* Users */}
              <div className="imageLinksContainer">
                {/* createPunch */}
                <Link to="" onClick={createPunch} className="punchIcon" >
                  <MdPunchClock  size={60} color={punchColor} />
                </Link>

                <Link to="" onClick={createDocument} className="punchIcon" style={{position: 'relative'}}>
                  <IoDocumentAttach  size={60} color={documentColor} />
                  { (documentCount && documentCount > 0) ?
                    <MdFiberNew name="burst-new" size={40} color="maroon" style={{position: 'absolute', top:0, right: -10}}/>
                  : null
                  }
                </Link>

                <Link to="" onClick={goToRequestsManager} className="punchIcon" style={{position: 'relative'}}>
                  <FaClipboardQuestion size={60} color={punchColor} />
                  { ((swapRequestCount || leaveRequestCount) && (swapRequestCount > 0 || leaveRequestCount > 0)) ?
                    <MdFiberNew name="burst-new" size={40} color="maroon" style={{position: 'absolute', top:0, right: -10}}/>
                  : null
                  }
                </Link>

                <Link to={t('link.users')} className="punchIcon" >
                  <FaUsers size={60} color={workerColor} />
                </Link>
              </div>
            </Container>
          {/* </Row> */}
        </div>
      </div>
    </>
  );
};
export default HomeScreen;